import { useT } from "@/i18n/I18nContext";
import {
  ShieldCheck, BadgeCheck, Clock, History, Headphones, Package, Handshake,
  Users, Star, Eye, Megaphone, BarChart3, LifeBuoy, TrendingUp,
} from "lucide-react";

const Row = ({ Icon, label }) => (
  <li className="flex items-center gap-3 py-2">
    <span className="h-9 w-9 rounded-xl bg-success/10 text-success flex items-center justify-center shrink-0">
      <Icon className="h-5 w-5" />
    </span>
    <span className="text-sm font-medium text-foreground">{label}</span>
  </li>
);

export const AdvantagesSection = () => {
  const { t } = useT();
  const buyers = [
    [ShieldCheck, "b1"], [BadgeCheck, "b2"], [Clock, "b3"], [History, "b4"],
    [Headphones, "b5"], [Package, "b6"], [Handshake, "b7"],
  ];
  const sellers = [
    [Users, "s1"], [Star, "s2"], [Eye, "s3"], [Megaphone, "s4"],
    [BarChart3, "s5"], [LifeBuoy, "s6"], [TrendingUp, "s7"],
  ];
  return (
    <section className="container-page py-14" data-testid="advantages-section">
      <div className="text-center max-w-2xl mx-auto mb-8">
        <h2 className="font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-foreground">{t("advantages.title")}</h2>
        <p className="text-muted-foreground mt-2">{t("advantages.subtitle")}</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="rounded-3xl bg-card border border-border p-6" data-testid="advantages-buyers">
          <h3 className="font-heading font-bold text-lg text-foreground mb-2">{t("advantages.buyers")}</h3>
          <ul className="divide-y divide-border/50">
            {buyers.map(([Icon, k]) => <Row key={k} Icon={Icon} label={t(`advantages.${k}`)} />)}
          </ul>
        </div>
        <div className="rounded-3xl bg-card border border-border p-6" data-testid="advantages-sellers">
          <h3 className="font-heading font-bold text-lg text-foreground mb-2">{t("advantages.sellers")}</h3>
          <ul className="divide-y divide-border/50">
            {sellers.map(([Icon, k]) => <Row key={k} Icon={Icon} label={t(`advantages.${k}`)} />)}
          </ul>
        </div>
      </div>
    </section>
  );
};

export const FutureModules = () => {
  const { t } = useT();
  const mods = [
    ["bandes", TrendingUp], ["partners", Handshake], ["club", Users],
    ["coach", LifeBuoy], ["stats", BarChart3], ["services", Package],
  ];
  return (
    <section className="container-page pb-16" data-testid="future-modules">
      <div className="mb-6">
        <h2 className="font-heading font-extrabold text-2xl sm:text-3xl tracking-tight text-foreground">{t("future.title")}</h2>
        <p className="text-muted-foreground mt-1.5">{t("future.subtitle")}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {mods.map(([k, Icon]) => (
          <div key={k} className="rounded-2xl bg-muted/40 border border-dashed border-border p-5 relative" data-testid={`future-${k}`}>
            <span className="absolute top-4 right-4 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-primary/10 text-primary pointer-events-none">{t("future.soon")}</span>
            <span className="h-11 w-11 rounded-xl bg-card border border-border flex items-center justify-center text-muted-foreground">
              <Icon className="h-5 w-5" />
            </span>
            <h3 className="mt-3 font-heading font-semibold text-foreground">{t(`future.${k}`)}</h3>
            <p className="text-sm text-muted-foreground mt-1">{t(`future.${k}Desc`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
